module.exports = __webpack_public_path__ + "img/total-package-warn_aqs.89372d6d.jpg";